<template>
  <el-container>
    <el-header class="hd-wrapper">
      <span>GC管理後台</span>
      <div class="login-info">
        <div class="user-info" v-if="userInfo">
          <img class="avatar" :src="smartImagePath(userInfo.avatar)" />
          <span>{{userInfo.nickname}}</span>
        </div>
        <el-button
          type="danger"
          size="small"
          @click="logout">
          退出
        </el-button>
      </div>
    </el-header>
    <el-container>
      <el-aside width="200px">
        <el-col :span="24">
          <el-menu
            router
            default-active="2"
            class="el-menu-vertical-demo"
            @open="handleOpen"
            @close="handleClose"
            background-color="#545c64"
            text-color="#fff"
            active-text-color="#ffd04b"
            >
            <el-menu-item
              v-for="item in asideNav"
              v-if="!item.children"
              :index="item.path"
              :key="item.name">
              <i v-if="item.icon" :class="item.icon"></i>
              <icon v-if="item.iconAws" :name="item.iconAws" class="iconAws"/>
              <span slot="title">{{item.name}}</span>
            </el-menu-item>
            <el-submenu
              v-else
              :key="item.name"
              :index="item.path">
              <template slot="title">
                <i v-if="item.icon" :class="item.icon"></i>
                <icon v-if="item.iconAws" :name="item.iconAws" class="iconAws"/>
                <span>{{item.name}}</span>
              </template>
              <el-menu-item-group>
                <el-menu-item
                  v-for="child in item.children"
                  :key="child.name"
                  :index="child.path">
                  {{child.name}}
                </el-menu-item>
              </el-menu-item-group>
            </el-submenu>
          </el-menu>
        </el-col>
      </el-aside>
      <el-main>
        <router-view></router-view>
      </el-main>
    </el-container>
  </el-container>
</template>

<script>
  import allAsideNav, { hasPermission } from '../router/asideNav.js'
  import { smartImagePath } from '../utils/object'
  import { mapState } from 'vuex'

  export default {
    data () {
      return {
        smartImagePath
      }
    },
    computed: {
      ...mapState({
        userInfo: state => state.user.userInfo
      }),
      roles () {
        return this.userInfo && this.userInfo.roles ? this.userInfo.roles : []
      },
      asideNav () {
        if (!this.roles || !this.roles.length) {
          return []
        }

        return allAsideNav.filter(item => {
          if (this.roles.includes('admin')) {
            return true
          }

          if (hasPermission(this.roles, item)) {
            if (item.children) {
              item.children = item.children.filter(child => {
                if (this.roles.includes('admin')) {
                  return true
                }

                if (hasPermission(this.roles, child)) {
                  return true
                }

                return false
              })
            }
            return true
          }

          return false
        })
      }
    },
    methods: {
      handleOpen (key, keyPath) {
        console.log(key, keyPath)
      },
      handleClose (key, keyPath) {
        console.log(key, keyPath)
      },
      logout () {
        this.$store.commit('LOGOUT')
        window.open('/login', '_self')
        // this.$router.replace(`/login?${this.$route.fullPath}`)
      }
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="less">
  .el-container{
    height: 100vh;
  }

  .el-header {
    background-color: #B3C0D1;
    color: #333;
    text-align: center;
    line-height: 60px;
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  .el-aside {
    background-color: #D3DCE6;
    color: #333;
    text-align: left;
    line-height: 200px;
    min-width: 200px;

    .el-col-24,
    .el-col-24 ul{
      height: 100%;
    }

  }

  .el-main {
    background-color: #E9EEF3;
    color: #333;
    text-align: center;
    line-height: 160px;
  }

  body > .el-container {
    margin-bottom: 40px;
  }


  .el-container .el-aside {
    line-height: 320px;
  }

  .iconAws{
    color: #878d99;
    width: 24px;
    height: 18px;
    margin-right: 5px;
  }

  .login-info {
    .user-info {
      display: inline-block;
      font-size: 14px;  
      vertical-align: middle;
      margin-right: 15px;

      .avatar {
        width: 30px;
        height: 30px;
        border-radius: 50%;
        object-fit: contain;
        vertical-align: middle;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/HelloWorld.vue